import { render, staticRenderFns } from "./comment-list-view.vue?vue&type=template&id=17354338&scoped=true"
import script from "./comment-list-view.vue?vue&type=script&lang=js"
export * from "./comment-list-view.vue?vue&type=script&lang=js"
import style0 from "./comment-list-view.vue?vue&type=style&index=0&id=17354338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17354338",
  null
  
)

export default component.exports